import initLargeCheckboxList from "../app_js/component/checkbox-list.js";
import _ from "../app_js/framework/components/popup.js";

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".cp-tabs").forEach((elt) => initTabSwitcher(elt));
  document.querySelectorAll('input[name="file"]').forEach((elt) => validateFileInputMaxSize(elt));
  document.querySelectorAll("[data-submit-on-change]").forEach((elt) => submitFormOnChange(elt));

  if (document.querySelector("[data-checkbox-list]")) {
    initLargeCheckboxList();
  }
});

function initTabSwitcher(elt) {
  const showTargetId = (target) => {
    elt.querySelectorAll(".cp-tabs__header button[active]").forEach((btn) => btn.removeAttribute("active"));
    elt.querySelector(`.cp-tabs__header button[data-target="${target}"]`).setAttribute("active", "true");
    elt.querySelectorAll(".cp-tabs__content [active]").forEach((content) => content.removeAttribute("active"));
    elt.querySelector(target).setAttribute("active", "true");
  };

  elt.querySelectorAll(".cp-tabs__header button").forEach((btn) => {
    btn.addEventListener("click", () => {
      showTargetId(btn.dataset.target);
    });
  });

  const firstButton = elt.querySelector(".cp-tabs__header button:first-child");
  showTargetId(firstButton.dataset.target);
}

function submitFormOnChange(input) {
  input.addEventListener("change", () => input.form.submit());
}

function validateFileInputMaxSize(fileInput) {
  const maxSize = parseInt(fileInput.dataset.maxSize);
  const errorElement = document.querySelector(`*[error-for="${fileInput.name}"]`);

  fileInput.addEventListener("change", () => {
    const file = fileInput.files[0];

    if (file?.size > maxSize) {
      errorElement.style.display = "block";
      fileInput.value = "";
    } else {
      errorElement.style.display = "none";
    }
  });
}
